import {
	darkTheme,
	NAlert,
	datePtBR,
	NConfigProvider,
	NDialogProvider,
	NLayout,
	NLayoutContent,
	NMessageProvider,
	NModalProvider,
	ptBR,
} from 'naive-ui';
import { computed, defineComponent, watchEffect } from 'vue';
import { RouterView } from 'vue-router';

import { AppHeader, AppLogin } from './components/App';
import { TutorialHost } from './features/Tutorial/TutorialHost';
import { AuthService } from './services';
import { Messages } from './constants/messages';
import { useAppStore, UserStore } from './stores';
import { darkThemeOverrides } from './themes/dark';
import { lightThemeOverrides } from './themes/light';

import './services/amplitudeService';

import { vMaska } from 'maska/vue';
import { AppMobileMenuBar } from './components/App/AppMenu/AppMobileMenuBar';
import { LoadingZoo } from './components/App/LoadingZoo';
import { useAppResize } from './compositions/useAppResize';
import { useVersionCheck } from './compositions/useVersionCheck';

import { NButton, NModal, NText } from 'naive-ui';

//@ts-expect-error problema de type
export const WebAppAlmada = defineComponent({
	directives: { maska: vMaska } as any,

	setup() {
		const userStore = UserStore();
		const appStore = useAppStore();

		const user = computed(() => userStore.user);
		const theme = computed(() => (userStore.appTheme == 'light' ? null : darkTheme));
		const themeOverride = computed(() =>
			userStore.appTheme == 'light' ? lightThemeOverrides : darkThemeOverrides,
		);
		// O tema vai para o <html> para o CSS próprio (main.scss) acompanhar o naive-ui: os tokens
		// --alm-* trocam de valor por `html[data-theme='dark']`, sem cada componente ler a store.
		watchEffect(() => {
			document.documentElement.dataset.theme = userStore.appTheme === 'dark' ? 'dark' : 'light';
		});
		const showLogin = computed(() => userStore.showLoginPrompt);
		const appState = computed(() => appStore.appState);
		const isMobile = appStore.isMobile;
		// Parceiro em "Pendente assinatura" ou "Pendente": entra, mas não cria nada até o comercial
		// ativar. O aviso fica no topo de todas as telas; os botões de criação mostram o mesmo motivo.
		const partnerPending = computed(() => userStore.partnerCreationBlockedMessage != null);
		const partnerWaitingSignature = computed(() => userStore.isPartnerWaitingSignature);

		useAppResize();
		const { showUpdateModal, reload } = useVersionCheck();

		return {
			locale: ptBR,
			dateLocale: datePtBR,
			user,
			theme,
			showLogin,
			themeOverride,
			appState,
			isMobile,
			partnerPending,
			partnerWaitingSignature,
			showUpdateModal,
			reload,
		};
	},

	mounted() {
		const auth = new AuthService();
		auth.authorizeFlow();
	},

	render() {
		if (!this.appState)
			return (
				<div class="centered">
					<div class="acrylic-card">
						<LoadingZoo size={64} />
					</div>
				</div>
			);

		return (
			<NConfigProvider
				style="height: calc(100vh); display: flex; flex-direction: column;"
				theme={this.theme}
				locale={this.locale}
				dateLocale={this.dateLocale}
				theme-overrides={this.themeOverride}
			>
				<NModalProvider>
					<NDialogProvider>
						<NMessageProvider>
							{!this.showLogin && (
								<NLayout content-style="height: 100%; min-height: 0; display: flex; flex-direction: column;">
									{!this.isMobile && <AppHeader />}
									{this.partnerPending && (
										<NAlert
											data-cy="partner-pending-banner"
											type={this.partnerWaitingSignature ? 'info' : 'warning'}
											bordered={false}
											style={{ borderRadius: 0, flexShrink: 0 }}
										>
											<p>{Messages.PARTNER_PENDING_ACTIVATION}</p>
											{this.partnerWaitingSignature && (
												<p>{Messages.PARTNER_PENDING_SIGNATURE}</p>
											)}
										</NAlert>
									)}
									<NLayoutContent class="app-base-layout">
										<RouterView></RouterView>
									</NLayoutContent>
									{this.isMobile && <AppMobileMenuBar />}
									<TutorialHost />
								</NLayout>
							)}
							{this.showLogin && (
								<NLayout class="app-base-layout" position="absolute">
									<AppLogin />
								</NLayout>
							)}
							{/* Modal de atualização de versão */}
							<NModal show={this.showUpdateModal} maskClosable={false} preset="dialog">
								<NText>Uma nova versão do sistema está disponível.</NText>
								<NButton type="primary" onClick={this.reload} style="margin-top: 16px;">
									Atualizar agora
								</NButton>
							</NModal>
						</NMessageProvider>
					</NDialogProvider>
				</NModalProvider>
			</NConfigProvider>
		);
	},
});

export default WebAppAlmada;
